<template>
	<div id="app" v-loading="isReady" :element-loading-text="( !installed ) ? 'A descarregar...' : 'A actualizar...'">
		<el-row id="header" class="container">
			<div class="stripe">
				<img src="static/img/stripe.svg" />
			</div>
			<div class="brand">
				<router-link to="/">
					<img src="static/img/logo.svg" />
				</router-link>
			</div>
		</el-row>
		<transition :name="transition" mode="out-in">
			<router-view></router-view>
		</transition>
		<el-row id="info" class="container">
			<el-col :span="3">
				<transition :name="transition" mode="out-in">
					<el-button id="back" v-if="!home" type="primary" size="small" icon="arrow-left" v-on:click="back">Voltar</el-button>
				</transition>
				<div class="ghost"></div>
			</el-col>
			<el-col :span="16" :offset="1" class="uppercase">Lisboa <a href="tel:+351219349490">219 349 490</a></el-col>
			<el-col :span="3" :offset="1">
				<el-button type="primary" size="mini" v-on:click="update"><svg width="20" height="20" viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="M17.553 3.428C15.747 1.615 13.253.49 10.49.49 4.965.49.503 4.965.503 10.49s4.462 10 9.987 10c4.657 0 8.557-3.187 9.663-7.5h-2.6c-1.03 2.913-3.794 5-7.063 5-4.143 0-7.5-3.356-7.5-7.5 0-4.143 3.357-7.5 7.5-7.5 2.07 0 3.925.863 5.282 2.22L11.74 9.24h8.75V.49l-2.937 2.938z" fill="#F2F2F2"/><path d="M-4.51-4.51h30v30h-30"/></g></svg></el-button>
			</el-col>
		</el-row>
	</div>
</template>

<script>

	export default {
		name: 'app',
		data () {
			return {
				transition: 'slide-right',
				isLocalhost: Boolean(window.location.hostname === 'localhost' || 
					window.location.hostname === '[::1]' ||
					window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/) )
			}
		},
		watch: {
			'$route' (to, from) {
				const toDepth = ('home' === to.name) ? 0 : to.path.split('/').length
    			const fromDepth = from.path.split('/').length
    			this.transition = ( toDepth < fromDepth ) ? 'slide-left' : 'slide-right'
			}
		},
		computed: {
			installed () {
				return this.$store.state.isInstalled
			},
			bootstraped () {
				return this.$store.state.isBootstraped
			},
			loading () {
				return this.$store.state.isLoading
			},
			isReady () {
				return  ( !this.installed || 
					( this.installed && !this.bootstraped ) || 
					( this.installed && this.loading ) )
			},
			home () {
				return ( '/' === this.$route.path )
			}
		},
		methods: {
			back () {
				this.$router.go(-1)
			},
			update () {
				if( navigator.onLine ){
					this.$store.dispatch( 'update' );
				}else{
					this.$notify.error({
						title: 'Sem ligação',
      					message: 'Verifique a sua ligação à Internet.'
					});
				}
			},
			readyToGo ( event ) {
				this.$store.dispatch( 'installed' )
			}
		},
		created (){
			if ( this.isLocalhost ) {
				setTimeout( () => this.$store.dispatch( 'installed' ), 5000 );
			}

			setTimeout(() => { if( !this.isReady ) {
				this.$store.dispatch( 'installed' )
				this.$store.dispatch( 'bootstrap' )
				this.$store.dispatch( 'unload' )
			} }, 10000);
		}
	}
</script>

<style lang="less">

	html, body{
		height: 100%;
	    overflow: hidden;
	}

	body {
		margin: 0px;
		padding: 0px;
		font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, SimSun, sans-serif;
		font-size: 14px;
		-webkit-font-smoothing: antialiased;
		background-color: #F2F2F2;
	}

	.uppercase{
		text-transform: uppercase;
	}

	.text-left{ text-align: left; }
	.text-center{ text-align: center; }

	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
		height: 100%;
	}

	#header{
		height: 150px;
		
		.stripe{
		}

		.brand{
			position: relative;
			margin-top: 30px;
		}

		.el-button{
			position: absolute;
			top: 9px;
			left: 4.16667%;
		}
	}

	#info{
		right: 0;
		bottom: 0;
		left: 0;
		background-color: #666666;
		padding: 20px 10px 15px 4.16667%;
		color: white;
		font-size: 20px;
		z-index: 10;

		.el-col{
			min-height: 1px;
		}

		a{
			color: white;
			text-decoration: none;
		}

		.spacer{
			padding: 0 15px;
		}

		.uppercase{
			padding-top: 2px;
		}

		#back{
			position: relative;
			top: 1px;
			float: left;
		}

	}

	.slide-right-enter-active, .slide-right-leave-active,
	.slide-left-enter-active, .slide-left-leave-active {
		transition: all 0.2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
	}
		
	.slide-right-enter{
		transform: translateX(30px);
		opacity: 0;
	} 
	
	.slide-right-leave-to{
		transform: translateX(-30px);
		opacity: 0;
	}

	.slide-left-enter{
		transform: translateX(-30px);
		opacity: 0;
	} 
	
	.slide-left-leave-to{
		transform: translateX(30px);
		opacity: 0;
	}

	#ua{
		font-size: 8px;
	}

</style>


// WEBPACK FOOTER //
// App.vue?6661af56